<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="popupTitle" width="1500px" @close="close()">
    <div slot="content">
      <el-row type="flex" :gutter="15" justify="space-between">
        <!-- 전체 노드 목록 -->
        <el-col :span="8">
          <el-row class="title-bar" type="flex" justify="space-between">
            <div class="vertical-center-box">선택한 노드 목록</div>
            <div class="vertical-center-box" align="right">
              <w-header-search-button @click="showNodeSearchTool = !showNodeSearchTool"></w-header-search-button>
            </div>
          </el-row>
          <el-table-wrapper ref="nodeTable" :column-default="columnDefault" :data="nodeList" :columns="nodeTableColumns" :show-search-tool="showSearchTool" :show-custom-header="true"
          row-class-name="c-dblclick" remote pagination :total="total.node" @condition-change="loadData" @pagination-change="handlerPaginationChange" @total-change="handlerPaginationChange">
            <template slot-scope="scope" slot="detail-slot">
              <span><i class="far fa-search-plus c-pointer" @click.stop="onClickDetailButton(scope.row)"></i></span>
            </template>
          </el-table-wrapper>
        </el-col>
        <!-- 선택한 노드 목록 -->
        <el-col :span="16">
          <el-row class="title-bar" type="flex" justify="space-between">
            <div class="vertical-center-box">수행 커맨드</div>
          </el-row>
          <el-form>
            <el-form-item v-for="task in selectedTaskList" :key="`${task.taskId}.${task.variableId}`" :label="`${task.taskId} 커맨드`">
              <el-input type="textarea" value="mkuser userid" :rows="4"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { columnDefault, defaultPagination, defaultDetailHeaderColumn } from '@/constants/table';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);
const pagination = cloneDeep(defaultPagination);

export default {
  name: 'WTriggerExecCommandPopup',
  props: {
    selectedTrgJob: {
      type: Object,
      default: () => ({ jobId: EMPTY_TEXT, jobName: EMPTY_TEXT }),
    },
  },
  data() {
    return {
      pagination,
      columnDefault,
      total: 0,
      showSearchTool: false,
      nodeTableColumns: [
        { prop: 'nodeName', label: '노드 명', searchable: true },
        { prop: 'nodeIp', label: '노드 IP 주소', searchable: true, formatter: defaultFormatter },
        { ...defaultDetailHeaderColumn, scopedSlot: 'detail-slot' },
      ],
      nodeList: [],
      selectedTaskList: [],
    };
  },
  computed: {
    popupTitle() {
      return isNil(this.selectedTrgJob) ? EMPTY_TEXT : `[${this.selectedTrgJob.jobName}] 작업 수행 커맨드`;
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.loadData();
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
    loadData() {
      if (!isNil(this.selectedTrgJob)) {
        this.nodeList = cloneDeep(this.selectedTrgJob.nodeInfos);
      }
    },
    handlerPaginationChange(_pagination) {
      this.pagination = _pagination;
    },
    onClickDetailButton(row) {
      this.selectedTaskList = row.taskInfo;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/TriggerSetting/popup/TriggerExecCommandPopup.vue